import React, { useState } from "react";
import { useForm } from "react-hook-form";

// components
import Input from "../shared/Form/Input";
import { getData, postData } from "../../services/API";
import Loading from "../shared/Loading";
import { useEffect } from "react";

const BlogSearch = ({ setPosts, setPages }) => {
  const { register, getValues } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [clear, setClear] = useState(false);

  useEffect(() => {
    if (searchVal) {
      setClear(true);
    } else {
      setClear(false);
    }
  }, [searchVal]);

  const submitHandler = (e) => {
    setLoading(true);

    postData("/blog/post/search", { search: searchVal })
      .then((res) => {
        setPosts(res.data.data);
        setPages(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const searchOnChangeHandler = (e) => {
    setSearchVal(e.target.value);
  };

  const clearSearchData = () => {
    setLoading(true);

    getData("/blog/index", {}, true)
      .then((res) => {
        setPosts(res.data.data);
        setPages(res.data);
        setLoading(false);
        setSearchVal("");
        setClear(false);
      })
      .catch((res) => {
        setLoading(false);
      });
  };

  return (
    <div className="w-full flex relative flex-col gap-3">
      {clear && (
        <button
          onClick={clearSearchData}
          className="h-8 w-8 flex justify-center items-center rounded-lg bg-gradient-to-tl top-[10px] from-red-600 to-red-300 shadow-lg shadow-test absolute left-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-5 h-5 fill-white"
          >
            <path
              fill-rule="evenodd"
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      )}

      <input
        type="text"
        value={searchVal}
        placeholder="دنبال چی میگردی ؟"
        className="focus:ring-yellow-700 bg-[#222222] w-full h-[50px] rounded-xl px-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg border border-gray-800 transition-all duration-200"
        onChange={searchOnChangeHandler}
      />

      <button
        className="rounded-xl h-11 bg-gradient-to-tl from-yellow-900 to-yellow-500 shadow-lg text-white w-full transition-all duration-300"
        onClick={submitHandler}
      >
        {loading ? (
          <Loading color={"before:!bg-white"} />
        ) : (
          <span>جست و جو</span>
        )}
      </button>
    </div>
  );
};

export default BlogSearch;
